export const mutations = {
    SET_NUMBER_TO_CALL: (state, numberToCall) => {              
        state.numberToCall = numberToCall;        
    },
   
    EMPTY_NUMBER_TO_CALL: (state) => {              
        state.numberToCall = null;        
    },
};
